import React from 'react';
import KnowledgeBase from '../../../pages/KnowledgeBase';

const AIKnowledgeBase: React.FC = () => {
  return <KnowledgeBase />;
};

export default AIKnowledgeBase;